export const tagsHandler = tags => {
  const tagHelper = tags?.reduce((acc, tag) => ({ ...acc, [tag.sys.id]: tag.name }), {}) || {};
  return tagHelper;
};

// Recieves an article (item) and returns an array of tag ids
export const extractTagIds = (article) => {
  return (article?.metadata?.tags || []).map(tag => tag?.sys?.id).filter(Boolean);
};